const COMPLETED_TRAINING_STATUSES = new Set([
  "assumed_completed", "completed_auto", "completed",
]);

export function isTrainingFeedbackPending(item, currentTime) {
  const category = String(item?.category || "").toLowerCase();
  if (!item?.training_feedback_required || !["training", "workout"].includes(category)) return false;
  if (!COMPLETED_TRAINING_STATUSES.has(item.status) || item.training_feedback_id) return false;
  const dueAt = Date.parse(item.training_feedback_due_at || "");
  const now = currentTime instanceof Date
    ? currentTime.getTime()
    : typeof currentTime === "number" ? currentTime : Date.parse(currentTime || "");
  return Number.isFinite(dueAt) && Number.isFinite(now) && dueAt <= now;
}
